export default __webpack_public_path__ + "static/media/pexels-ivan-samkov-49891641.9ee61762.jpg";